import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const AddIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M17.38 3.82C19.14 3.82 20.14 4.82 20.14 6.58V17.34C20.14 19.1 19.14 20.1 17.38 20.1H6.62C4.86 20.1 3.86 19.1 3.86 17.34V6.58C3.86 4.82 4.86 3.82 6.62 3.82H17.38ZM6.72 5.46C6.02 5.46 5.5 5.98 5.5 6.68V17.24C5.5 17.94 6.02 18.46 6.72 18.46H17.28C17.98 18.46 18.5 17.94 18.5 17.24V6.68C18.5 5.98 17.98 5.46 17.28 5.46H6.72ZM15.74 12.78H12.82V15.7H11.18V12.78H8.26V11.12H11.18V8.22H12.82V11.12H15.74V12.78Z" />
    </SvgIcon>
  );
});
